import { Col } from 'components';
import styled from 'styled-components';

export const NetWrapper = styled(Col)`
  background: ${({ theme }) => theme.color.white};
  padding: ${({ theme }) => `${theme.spacing.m}`};
  border-radius: ${({ theme }) => theme.borderRadius.m};
`;
